
import { readUserProfile } from "@/store/main/getters";
import { Vue, Component } from "vue-property-decorator";
import {getDocLink} from "@/i18n/locales";

@Component({
  methods: {getDocLink},
  components: {},
})
export default class Footer extends Vue {
  get userProfile() {
    return readUserProfile(this.$store);
  }
}
